import React, {useState, useEffect} from 'react'
import {PayPalButtons, usePayPalScriptReducer} from '@paypal/react-paypal-js'
import {toast} from 'react-toastify'
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min'
import CashPaymentForm from './CashPayment'
const PaymentForm = ({customerdetail, policydetail, payment_detail, type}) => {
  const [{isPending, isError}] = usePayPalScriptReducer()
  const history = useHistory()

  const amount = policydetail?.grandtotaltermpremium || '0.00'

  useEffect(() => {
    if (isError) {
      alert('There was an error loading the PayPal script.')
    }
  }, [isError])

  return (
    <div className="container mt-3">
      <div className="card p-4">
        {type == 'Cash' ? (
          <CashPaymentForm policydetail={policydetail} paymentType={type} />
        ): type == 'BankTransfer' ? (
          <CashPaymentForm policydetail={policydetail} paymentType={type} />
        ) : (
          <div
            className="checkout"
            style={{
              padding: '20px',
              maxWidth: '400px',
              minHeight: '150px',
              minWidth: '300px',
            }}>
            {isPending ? (
              <p>Loading PayPal...</p>
            ) : (
              <PayPalButtons
                // fundingSource="card"
                forceReRender={[amount]}
                style={{
                  layout: 'vertical',
                  label: 'paypal',
                  shape: 'rect',
                  color: 'blue',
                }}
                createOrder={(data, actions) => {
                  const name = customerdetail?.clientfirstname || ''
                  const email = customerdetail?.clientemailaddress || ''
                  const nationalid = customerdetail?.nationalid || ''
                  const policynumber = policydetail?.policynumber || ''
                  const insurerId = policydetail?.insurerId || ''
                  const productid = policydetail?.productid || ''
                  const policyid = policydetail?.policyid || ''

                  return actions.order.create({
                    purchase_units: [
                      {
                        amount: {
                          value: amount,
                        },
                        description: `Policy Payment - ${policydetail?.policynumber}`,
                        custom_id: JSON.stringify({name, email}).slice(0, 127),
                        reference_id: JSON.stringify({
                          nationalid,
                          insurerId,
                          productid,
                          policyid,
                          policynumber,
                        }).slice(0, 256),
                      },
                    ],
                  })
                }}
                onApprove={(data, actions) => {
                  return actions.order.capture().then(details => {
                    const purchaseUnit = details?.purchase_units?.[0]
                    const customData = JSON.parse(
                      purchaseUnit?.custom_id || '{}',
                    )
                    const referenceData = JSON.parse( 
                      purchaseUnit?.reference_id || '{}',
                    )
                    console.log('Custom Data:', customData)
                    console.log('Reference Data:', referenceData, '====' ,data)
                    toast.success(
                      `${customData?.name || 'User'}, payment successful!`,
                    )
                    history.push('/policies')
                  })
                }}
                onError={err => {
                  toast.error('There was an error during the payment process')
                  console.error(err)
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PaymentForm
